import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { SectionRowViewModel } from '../../../../display/components/menus/product-menu/building-blocks/menu-section/product-section/section-row-view-models/SectionRowViewModel';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { exists } from '../../../../../functions/exists';
import { HeaderColumnComponent } from '../header-column.component';
import { SectionColumnCannabinoidType } from '../../../../../models/enum/shared/section-column-cannabinoid-type';

@Component({
  selector: 'app-header-column-cannabinoid',
  templateUrl: './header-column-cannabinoid.component.html',
  styleUrl: './header-column-cannabinoid.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HeaderColumnCannabinoidComponent extends HeaderColumnComponent implements AfterViewInit, OnChanges {
  constructor(protected renderer: Renderer2) {
    super();
  }

  @Input() cannabinoidColumnType: keyof typeof SectionColumnCannabinoidType;
  @Input() sectionRowViewModels: SectionRowViewModel[];
  protected _sectionRowVMsSubject = new BehaviorSubject<SectionRowViewModel[]>([]);
  public sectionRowViewModels$ = this._sectionRowVMsSubject as Observable<SectionRowViewModel[]>;
  @ViewChild('cannabinoidHeader') cannabinoidHeader: ElementRef<HTMLDivElement>;
  private currentCannabinoidClass: string;

  protected showCUOMInHeader$ = this.sectionRowViewModels$.pipe(
    map(vms => {
      if (exists(vms?.length) && vms?.firstOrNull()?.menu?.menuOptions?.showCUOMInHeader) {
        return vms
          ?.map(vm => vm?.getRowUniqueCUOM())
          ?.filter(cuom => exists(cuom))
          ?.uniqueInstance(true);
      }
      return null;
    })
  );

  public headerCUOMString$ = this.showCUOMInHeader$.pipe(map(CUOM => (exists(CUOM) ? `(${CUOM})` : '')));

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.updateClass();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.cannabinoidColumnType) this.updateClass();
    if (changes.sectionRowViewModels) this._sectionRowVMsSubject.next(this.sectionRowViewModels);
  }

  private updateClass(): void {
    const thcAndCbd = this.cannabinoidColumnType === SectionColumnCannabinoidType.THCAndCBD;
    if (exists(this.cannabinoidHeader?.nativeElement) && !thcAndCbd) {
      this.renderer.removeClass(this.cannabinoidHeader.nativeElement, this.currentCannabinoidClass);
      this.currentCannabinoidClass = `section-header-${this.cannabinoidColumnType?.toLowerCase()}`;
      this.renderer.addClass(this.cannabinoidHeader?.nativeElement, this.currentCannabinoidClass);
    }
  }
}
